import { getDecodedJwt } from '@/utils/getDecodedJwt';

export function isTokenAuthenticated(accessToken?: string): boolean {
  if (!accessToken) {
    return false;
  }

  try {
    const token = getDecodedJwt(accessToken);

    return token.atype === 'identity' || Boolean(token.mvpdid);
  } catch {}

  return false;
}
